import {Component, ElementRef, OnDestroy, ViewChild} from '@angular/core';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {User} from '../../../../../models/user';
import {AccountType} from '../../../../../models/account-type';
import {MonitoringType} from '../../../../../models/monitoring-type';
import {ValidationInfoService} from '../../../../../repositories/validation-info.service';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {FocusInvalidService} from '../../../../../services/focus-invalid.service';
import {Subscription} from 'rxjs';
import {StagesNavigationService} from '../../../stages-navigation/stages-navigation.service';
import {validateOptionalRequired} from '../../../../../services/validators';
import {InfoDialogService} from '../../../../../components/info-dialog/info-dialog.service';
import {MonitoringInfoComponent} from './monitoring-info/monitoring-info.component';
import {formLog} from '../../../../../services/debug-logger';

@Component({
  standalone: false,
  selector: 'app-account-type',
  templateUrl: './account-type.component.html',
  styleUrls: ['./account-type.component.scss']
})
export class AccountTypeComponent implements OnDestroy {
  userModel: User;
  accountTypeForm: FormGroup;
  accountType = AccountType;
  monitoringType = MonitoringType;
  @ViewChild('accountTypeElement') accountTypeElement: ElementRef;
  private subscription: Subscription;
  private formSub = new Subscription();

  constructor(
    service: BusinessDataService,
    private validationService: ValidationInfoService,
    private formBuilder: FormBuilder,
    private focusInvalidService: FocusInvalidService,
    private infoService: InfoDialogService,
    public navigationService: StagesNavigationService
  ) {
    this.formSub.add(service.GetUser().subscribe(u => {
      this.userModel = u.model;
      this.patchFormFromModel();
    }));

    this.buildForm();
    this.patchFormFromModel();
    this.formSub.add(this.accountTypeForm.valueChanges.subscribe(() => this.syncModelFromForm()));

    this.subscription = this.validationService.onUserUpdate.subscribe(() => {
      this.validationService.markAllFieldsAsTouched(this.accountTypeForm);

      this.focusInvalidService.selectInvalidInput(this.accountTypeElement);
      this.validationService.validate(this.accountTypeForm.valid, 'AccountTypeComponent');
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.formSub.unsubscribe();
  }

  openMonitoringInfo() {
    this.infoService.show(MonitoringInfoComponent);
  }

  private buildForm() {
    this.accountTypeForm = this.formBuilder.group({
      // purposeType: new FormControl('', validateOptionalRequired(() => true)),
      accountType: new FormControl('', validateOptionalRequired(() => true)),
      monitoringType: new FormControl('', validateOptionalRequired(() => true)),
    });
  }

  private patchFormFromModel(): void {
    if (!this.userModel || !this.accountTypeForm) { return; }
    this.accountTypeForm.patchValue({
      accountType: this.userModel.accountType ?? '',
      monitoringType: this.userModel.monitoring ?? '',
    }, {emitEvent: false});
    formLog.state('AccountType', this.userModel, this.accountTypeForm);
  }

  private syncModelFromForm(): void {
    if (!this.userModel) { return; }
    const value = this.accountTypeForm.getRawValue();
    this.userModel.accountType = value.accountType;
    this.userModel.monitoring = value.monitoringType;
    formLog.state('AccountType', this.userModel, this.accountTypeForm);
  }
}
